export const REPORT_MODES = {
  combined: 'combined',
  individual: 'individual',
  both: 'both'
}

export const reportModeOptions = t => [
  { label: t('Combined'), value: REPORT_MODES.combined },
  { label: t('Individual'), value: REPORT_MODES.individual },
//  { label: t('Individual & Combined'), value: REPORT_MODES.both }
]

export const defaultGetUserKey = row => row?.created_by || row?.name || 'unknown'

export const defaultGetUserName = row => {
  if (
    row?.name &&
    row?.created_by &&
    String(row.name) === String(row.created_by)
  )
    return row.name
  if (row?.name && row?.created_by) return `${row.name} (${row.created_by})`
  return row?.name || row?.created_by || '-'
}

export const splitSectionsByUser = (
  data,
  { getUserKey = defaultGetUserKey, getUserName: getUserLabel = defaultGetUserName } = {}
) => {
  return (data || []).map(section => {
    const users = []
    const userMap = {}

    ;(section?.rows || []).forEach(row => {
      const key = getUserKey(row)
      if (!userMap[key]) {
        userMap[key] = { key, label: getUserLabel(row), rows: [] }
        users.push(userMap[key])
      }
      userMap[key].rows.push(row)
    })

    return {
      group_name: section?.group_name,
      total: section?.total,
      users
    }
  })
}
